import React from "react";
import { withTranslation } from "react-i18next";
import { Full as Loader } from "../components/loaders/full";
import { Config } from "../app.config";
import PhoneInput, { isPossiblePhoneNumber } from "react-phone-number-input";

class VerifyRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNumber: "",
            codeNumber: "",
            msg: "",
            loader: false
        };
        this.on = {
            phoneChange: (value) => {
                this.setState({ phoneNumber: value });
            },
            codeNumberChange: (event) => {
                this.setState({ codeNumber: event.target.value });
            },
            verify: () => {
                this.setState({ loader: true });

                const data = {
                    phone: this.state.phoneNumber,
                    code: this.state.codeNumber
                };
                fetch(Config.routes.validateSMSCode, {
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data)
                }).then((res) => {
                    this.setState({ loader: false });
                    if (res.status === 200) {
                        this.props.onChange(this.state.phoneNumber);
                    } else {
                        return res.json();
                    }
                }).then(result => {
                    if (result && typeof result.msg === "string") {
                        this.setState({ msg: result.msg });
                    }
                });
            },
            resendSMS: () => {
                this.setState({ loader: true });

                const data = { phone: this.state.phoneNumber };
                fetch(Config.routes.sendSMSCods, {
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data)
                }).then((res) => {
                    this.setState({ loader: false });
                    if (res.status !== 200) {
                        return res.json();
                    }
                }).then(result => {
                    if (result && typeof result.msg === "string") {
                        this.setState({ msg: result.msg });
                    }
                });
            }
        };
    }

    componentDidMount() {
        this.setState({ phoneNumber: this.props.currentphone() });
    }

    render() {
        const { t, i18n } = this.props;
        const { phoneNumber, codeNumber, msg, loader } = this.state;
        const isPhoneNumber = phoneNumber && isPossiblePhoneNumber(phoneNumber);
        const isCodeEmpty = codeNumber.trim() === "";

        // Set default country dynamically based on language
        const defaultCountry = i18n.language === "he" ? "IL" : "US";

        return (
            <section className="z-10 text-gray-700 body-font">
                <div className="relative z-10 container">
                    <div className="z-10 xl:w-12/12 lg:w-12/12 w-full mx-auto text-center">
                        <h2 className="w-full my-2 text-2xl font-bold leading-tight text-center text-gray-800">
                            {t("verify_phone_number")}
                        </h2>
                        <div className="w-full mb-4">
                            <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
                        </div>
                        <div className="leading-relaxed text-lg text-center">
                            <label htmlFor="phone-number-input" className="block mt-4 text-left">
                                {t("sent_sms_verification")}
                            </label>
                            <PhoneInput
                                international
                                defaultCountry={defaultCountry}
                                placeholder={t("phone_placeholder")}
                                value={phoneNumber}
                                onChange={this.on.phoneChange}
                            />
                            <label htmlFor="code-input" className="block mt-4 text-left">
                                {t("enter_code")}
                            </label>
                            <div className="flex items-center">
                                <input
                                    type="number"
                                    id="code-input"
                                    placeholder={t("code_placeholder")}
                                    className="border border-gray-300 focus:outline-none focus:border-blue-500 rounded-md py-2 px-4 mt-2 w-full"
                                    onChange={this.on.codeNumberChange}
                                />
                                <button
                                    className={`flashing text-white bg-blue-900 border-0 mt-2 ml-3 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg ${
                                        isCodeEmpty ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                    onClick={this.on.verify}
                                    disabled={isCodeEmpty}
                                >
                                    {t("verify")}
                                </button>
                            </div>
                            <button
                                className={`mr-5 text-blue-900 underline mt-5 py-2 px-0 focus:outline-none hover:text-blue-600 ${
                                    !isPhoneNumber ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                                onClick={this.on.resendSMS}
                                disabled={!isPhoneNumber}
                            >
                                {t("resend_code")}
                            </button>
                        </div>
                    </div>
                    {msg ? (
                        <h1 style={{ color: "red" }} className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                            {t("error")}: {msg}
                        </h1>
                    ) : null}
                </div>
                {loader ? <Loader loaderText={t("verifying")} /> : null}
            </section>
        );
    }
}

export default withTranslation()(VerifyRegistration);
